import { apiService } from "@/core/services";

export const HOME = {
  getAppsList,
  exportSubscriptionExcel,
};

const URL = {
  ALI: "ali",
  CREATED_ACCOUNT_LOG: "created-account-log",
  EXPORT: "export",
};

function getAppsList(data) {
  let requestOptions = {
    params: {
      app_name: data.appName,
      page_size: data.perPage,
      page_num: data.page,
    },
  };

  return apiService().get(
    `/${URL.ALI}/${URL.CREATED_ACCOUNT_LOG}`,
    requestOptions
  );
}

function exportSubscriptionExcel() {
  return apiService().get(`/${URL.ALI}/${URL.CREATED_ACCOUNT_LOG}`);
}
